// extracted by mini-css-extract-plugin
export default {"titleDiv":"RechargeRecord_titleDiv__WM9PN","title0":"RechargeRecord_title0__wUOIq","title1":"RechargeRecord_title1__bdG0a"};